export function noop() {
}

export const isObject = (obj: unknown): obj is {} => {
  return obj != null && typeof obj === "object" && !Array.isArray(obj);
};
